import { getApiErrorMessage } from '@/shared/utils/handleApiError';

export { getApiErrorMessage };

export function handleApiError(vm, error, fallbackMessage) {
  const data = error && error.response && error.response.data;
  const title = (data && data.title) || 'Erro';

  vm.$notification.error({
    message: title,
    description: getApiErrorMessage(error, fallbackMessage),
  });
}
